
import { defineComponent, ref, reactive, inject, onMounted, watch } from "vue";
import { ElMessageBox } from "element-plus";
import { bdList, checkBd, bdInfo, addWolfOrder, getOrderCarSelectList } from "@/api/shenghuiHttp";
import { getAdminList } from "@/api/http";

export default defineComponent({
    name: "Guarantee",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["保单列表"]);

        const headClass = inject("headClass");
        const loading = ref(false);
        const tableData = ref([] as any[]);
        const total = ref(0);
        const dateRange = ref([] as any);
        const pageSize = ref(10);
        const currentPage = ref(1);
        const adminList = ref([] as any[]);
        const adminId = ref(null as any);
        const insuranceList = ref([] as any[]);
        const bxgs = ref(null as any);

        const getTableData = (): void => {
            loading.value = true;
            const data: any = {
                page: currentPage.value,
                pagesize: pageSize.value,
            };
            if (dateRange.value && dateRange.value.length === 2 && dateRange.value[0] && dateRange.value[1]) {
                data.start_time = Math.floor(dateRange.value[0].getTime() / 1000);
                data.end_time = Math.floor(dateRange.value[1].getTime() / 1000);
            }
            if (adminId.value) {
                data.admin_id = adminId.value;
            }
            if (bxgs.value) {
                data.bxgs = bxgs.value;
            }
            bdList(data).then((res: any) => {
                tableData.value = res?.content?.list || [];
                total.value = res?.content?.count || 0;
                loading.value = false;
            }).catch(() => {
                loading.value = false;
            });
        };

        const handleSizeChange = (size: number) => { pageSize.value = size; currentPage.value = 1; getTableData(); };
        const handleCurrentChange = (page: number) => { currentPage.value = page; getTableData(); };

        const getAdminListData = (): void => {
            getAdminList({}).then((res: any) => {
                adminList.value = res?.content?.list || [];
            });
        };

        // 保险公司列表
        const getInsuranceList = (): void => {
            getOrderCarSelectList().then((res: any) => {
                insuranceList.value = res?.content?.insurance_data || [];
            });
        };

        // 详情
        const detailForm = reactive({
            dialog_show: false,
            loading: false,
            info: {} as any,
        });
        const openDetailDialog = (row: any) => {
            detailForm.dialog_show = true;
            detailForm.loading = true;
            bdInfo({ id: row.id }).then((res: any) => {
                detailForm.info = res?.content?.info || {};
                detailForm.loading = false;
            }).catch(() => {
                detailForm.loading = false;
            });
        };

        //通过
        const detailPass = () => {
            ElMessageBox.confirm(
                `确认通过车牌【${detailForm.info.car_code}】的保单吗？`,
                '通过确认',
                { confirmButtonText: '确认', cancelButtonText: '取消', type: 'warning' }
            ).then(() => {
                checkBd({ id: detailForm.info.id, status: 1 }).then((res: any) => {
                    if (res.status == 202) {
                        detailForm.dialog_show = false;
                        getTableData();
                    }
                });
            }).catch(() => { });
        };

        // 修改
        const editForm = reactive({
            dialog_show: false,
            loading: false,
            id: 0,
            data_id: 0,
            car_id: 0,
            cd_id: 0,
            oder_date: "" as any,
            expiration_time: "" as any,
            syx_time: "" as any,
            ywx_time: "" as any,
            car_code: "",
            brand: "",
            vin: "",
            contact_phone: "",
            bxgs: "",
            tgr: "",
            issuer_name: "",
            syxje: "",
            sybx: "",
            jqxje: "",
            jqx_rate: "",
            cqs: "",
            ywx: "",
            ywxa: "",
            bxtc: "",
            total: "",
            shfbxgs: "",
            bxgsfje: "",
            fdcy: "",
            zx: "1",
            zsxm: "",
            zscb: "",
            remark: "",
        });
        const calcEditTotal = () => {
            const syxje = parseFloat(editForm.syxje) || 0;
            const jqxje = parseFloat(editForm.jqxje) || 0;
            const cqs = parseFloat(editForm.cqs) || 0;
            const ywx = parseFloat(editForm.ywx) || 0;
            editForm.total = (syxje + jqxje + cqs + ywx).toFixed(2);
        };
        const calcEditFdcy = () => {
            const shfbxgs = parseFloat(editForm.shfbxgs) || 0;
            const bxgsfje = parseFloat(editForm.bxgsfje) || 0;
            editForm.fdcy = (shfbxgs - bxgsfje).toFixed(2);
        };
        const openEditDialog = (row: any) => {
            editForm.dialog_show = true;
            editForm.loading = true;
            bdInfo({ id: row.id }).then((res: any) => {
                const info = res?.content?.info || {};
                editForm.id = info.id || row.id;
                editForm.data_id = info.data_id || 0;
                editForm.car_id = info.car_id || 0;
                editForm.cd_id = info.cd_id || 0;
                editForm.oder_date = info.oder_date ? new Date(info.oder_date) : "";
                editForm.expiration_time = info.expiration_time ? new Date(info.expiration_time) : "";
                editForm.syx_time = info.syx_time ? new Date(info.syx_time) : "";
                editForm.ywx_time = info.ywx_time ? new Date(info.ywx_time) : "";
                editForm.car_code = info.car_code || info.car?.code || "";
                editForm.brand = info.car?.model_name || info.car?.series_name || "";
                editForm.vin = info.car?.vin || "";
                editForm.contact_phone = info.contact_phone || "";
                editForm.bxgs = info.bxgs != null ? String(info.bxgs) : "";
                editForm.tgr = info.tgr || "";
                editForm.issuer_name = info.admin?.nickname || "";
                editForm.syxje = info.syxje || "";
                editForm.sybx = info.sybx || "";
                editForm.jqxje = info.jqxje || "";
                editForm.jqx_rate = info.jqx_rate || "";
                editForm.cqs = info.cqs || "";
                editForm.ywx = info.ywx || "";
                editForm.ywxa = info.ywxa || "";
                editForm.bxtc = info.bxtc || "";
                editForm.total = info.total || "";
                editForm.shfbxgs = info.shfbxgs || "";
                editForm.bxgsfje = info.bxgsfje || "";
                editForm.fdcy = info.fdcy || "";
                editForm.zx = info.zx || "1";
                editForm.zsxm = info.zsxm || "";
                editForm.zscb = info.zscb || "";
                editForm.remark = info.remark || "";
                editForm.loading = false;
            }).catch(() => {
                editForm.loading = false;
            });
        };
        const editSubmit = () => {
            const d = editForm.oder_date as Date;
            const oderStr = d ? `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}` : "";
            addWolfOrder({
                id: editForm.id,
                car_id: editForm.car_id,                       //车id
                car_code: editForm.car_code,                   //车牌号
                data_id: editForm.data_id,                     //操作的数据id

                contact_phone: editForm.contact_phone,         //联系方式
                bxgs: Number(editForm.bxgs),                   //保险公司
                tgr: editForm.tgr,                             //车主姓名

                oder_date: oderStr,                            //出单日期
                cd_id: editForm.cd_id,                         //出单员
                zx: editForm.zx,                               //是否续保

                expiration_time: editForm.expiration_time,     //交强险到期日
                jqxje: editForm.jqxje,                         //交强险金额
                jqx_rate: editForm.jqx_rate,                   //交强险政策

                syx_time: editForm.syx_time,                   //商业险到期日
                syxje: editForm.syxje,                         //商业险金额
                sybx: editForm.sybx,                           //商业险政策

                ywx_time: editForm.ywx_time,                   //意外险到期日
                ywx: editForm.ywx,                             //意外险金额
                ywxa: editForm.ywxa,                           //意外险政策

                shfbxgs: editForm.shfbxgs,                     //客户佣金
                bxgsfje: editForm.bxgsfje,                     //保险公司佣金
                fdcy: editForm.fdcy,                           //返点差异

                cqs: editForm.cqs,                             //车船税
                bxtc: editForm.bxtc,                           //保险提成
                total: editForm.total,                         //总保险合计

                zsxm: editForm.zsxm,                           //赠送项目
                zscb: editForm.zscb,                           //赠送成本
                remark: editForm.remark,                       //备注
            }).then((res: any) => {
                if (res.status == 202) {
                    editForm.dialog_show = false;
                    getTableData();
                }
            });
        };
        // 自动计算编辑表单的总保险合计和返点差异
        watch(
            () => [editForm.syxje, editForm.jqxje, editForm.cqs, editForm.ywx],
            () => { calcEditTotal(); }
        );
        watch(
            () => [editForm.shfbxgs, editForm.bxgsfje],
            () => { calcEditFdcy(); }
        );

        // 审核通过
        const handleDeal = (row: any) => {
            ElMessageBox.confirm(
                `确认审核通过车牌【${row.car?.code}】的保单吗？`,
                '审核确认',
                { confirmButtonText: '确认', cancelButtonText: '取消', type: 'warning' }
            ).then(() => {
                checkBd({ id: row.id, status: 2 }).then((res: any) => {
                    if (res.status == 202) {
                        getTableData();
                    }
                });
            }).catch(() => { });
        };

        onMounted(() => {
            getTableData();
            getAdminListData();
            getInsuranceList();
        });

        return {
            headClass,
            loading,
            tableData,
            total,
            dateRange,
            pageSize,
            currentPage,
            adminList,
            adminId,
            insuranceList,
            bxgs,
            getTableData,
            handleSizeChange,
            handleCurrentChange,
            handleDeal,
            detailForm,
            openDetailDialog,
            detailPass,
            editForm,
            openEditDialog,
            editSubmit,
        };
    },
});
